import Flash from "./flash";

import $ from "jquery";

const Tabs = {
  swapTab: function(link, tabName) {
    $(link).parents('ul:first').find('li').removeClass('active');
    $(link).parents('li:first').addClass('active');
    $('.tab-content[id*="tab"]').hide().removeClass('hidden');
    $('#tab-' + tabName).show();

    return false;
  },

  swapTabAndClearFlash: function(element, name) {
    Flash.hide();
    this.swapTab(element, name);

    return false;
  }
};

export default Tabs;
